export const issuesInfo = [
  { //issues not working: tide, out of bounds
    picture: require("../../static/issues/fervor.jpg"),
    title: "Fervor",
    link: "https://heyzine.com/flip-book/b50653e2ad.html", // Placeholder link - update when live
    description: "In a culture shaped by immediacy, automation, and endless consumption, it is tempting to slip into apathy. It's easy to disengage, to let the world pass through us without anchoring to it. FERVOR is our refusal. It is our commitment to doing the difficult, messy, vibrant work of creating, connecting, and showing up.",
  },
  { 
    picture: require("../../static/issues/pandora_box.jpg"),
    title: "Pandora's Box",
    link: "https://heyzine.com/flip-book/ab37d78b18.html", // Placeholder link - update when live
    description: "Mini zine issue",
  },
  { 
    picture: require("../../static/issues/Diorama_Master.jpg"),
    title: "Diorama",
    link: "https://heyzine.com/flip-book/15a15f7e18.html", // Placeholder link - update when live
    description: "Last year, we released METAMORPHOSIS, delving into growth and revolution, and then OUT OF BOUNDS, where we celebrated what it means to be different and push boundaries. Throughout these explorations, we kept coming back to an idea: Movement and transformation are likely best leaning on the edge. They lie not in resolution but in process. With this issue, we explore DIORAMA—a realm of intersecting narratives and liminal spaces, those in-betweens that lie at the heart of our existence.",
  },
  { 
    picture: require("../../static/issues/An_Homage.jpg"),
    title: "An Homage to: ",
    link: "https://heyzine.com/flip-book/2e842051e7.html", // Placeholder link - update when live
    description: "Over the summer, TREND members got together to create our very first summer zine, paying homage to the work of 3 designers\n\n" +
"- Martin Margiela (Dan Nepomuceno, Silvia Lee, Krista Vener, Ahliyah Luna, Preeya Govil)\n" +

"- Karl Lagerfeld (Preeya Govil, Venice Poggi)\n" +

"- Iris Van Herpen (Venice Poggi, Viviana Espino, Renee Agatep, Sophia Reiger, Sydney McDonald)\n\n" +

"TREND has always strived to welcome a unique group of artists, each with their own styles, expressions, and interpretations of what “fashion”, as a whole, really is. \n\n" +

"In this special inaugural issue, not only did we desire to understand and reconnect with the artistic impact of these designers, but we sought to take apart their work and create our own version of an artistic identity. \n\n" +

"With each curated look, shoot, writing piece, and spread, we developed a greater understanding of both our craft and the influences that inspired it. \n\n" +

"However, as much as we may look up to these designers and their impact on our own art, we cannot view them as immune to criticism. \n\n" +

"“Our idols, just like ourselves, are imperfect.”",
  },
  {
    picture: require("../../static/issues/out-of-bounds.jpg"),
    title: "Out of Bounds",
    link: "https://heyzine.com/flip-book/e3be461c1f.html",
    description: "With \"Out of Bounds,\" we have reached our final potential: we know who we are, we aren't afraid to speak out and disrupt the norm. Out of Bounds captures what it means to be different, to push the boundaries, and break out of them entirely. People who do so are often ostracized for their differences—and yet, they forge on anyway and revolutionize culture as we know it. Out of Bounds honors the artist's past and celebrates the independent spirit, particularly how it relates to our generation.",
  },
  {
    picture: require("../../static/issues/metamorphosis.jpg"),
    title: "METAMORPHOSIS",
    link: "https://issuu.com/trenducsd/docs/trend_fw23-24_1_",
    description: "The world changes, and us with it. We are growing every day, our wings strengthening. We become bigger, better versions of who we were yesterday. Metamorphosis is the very essence of worldly context at this very point in time, and us in it. Metamorphosis is our celebration of the past, present, and future. Metamorphosis is a declaration that you can be anything, anyone you want to be. In this issue, we looked towards nature, to find our strength in the sea and the land. We looked inward at our own change. We looked outward and observed the changes all around us, in fashion, media, and popular culture, even in the faces of generations past. We celebrate Palestine and we celebrate queer identity. We grapple with the aches and pains of growing up. And we marvel at what is to come.",
  },
  {
    picture: require("../../static/issues/vault.jpg"),
    title: "Vault",
    link: "https://issuu.com/trenducsd/docs/trend_fw23",
    description: "Vault celebrates the underground, the deeply personal; items meaningful to us and nonsensical to others are still valued beyond these differences - an artistic act of self-expression. Vault is our enjoyment of the retro, the vintage, and the avant garde.",
  },
  {
    picture: require("../../static/issues/tide.jpg"),
    title: "Tide",
    link: "https://issuu.com/trenducsd/docs/tide_issue",
    description: "Like the alternating rise and fall of the tide itself, the definition of \"tide\" constantly shifts. We explored how \"tide\" has showcased itself in the past and present, be it through representation in period cinema or inclusivity in surf culture. Above all, we hope that you, our reader, can see and understand our vision of \"tide\" as synonymous with \"seasons of change\".",
  },
  {
    picture: require("../../static/issues/revival.jpg"),
    title: "Revival",
    link: "https://issuu.com/trenducsd/docs/revival_issue_fw22",
    description: "Like the alternating rise and fall of the tide itself, the definition of the word \"tide\" constantly shifts. In this issue, we explored how \"tide\" has showcased itself in the past and present, be it through representation in period cinema or inclusivity in surf culture. Above all, we hope that you, our reader, can see and understand our vision of \"tide\" as \"seasons of change\".",
  },
  {
    picture: require("../../static/issues/unveiled.jpg"),
    title: "Unveiled",
    link: "https://issuu.com/trenducsd/docs/trend_ss21_unveiled",
    description: "Our Spring/Summer 2021 issue highlights the feelings of human beings rarely discussed in our ever-changing, fast-paced world. Slow down and read on."
  },
  {
    picture: require("../../static/issues/dream-theory.jpg"),
    title: "Dream Theory",
    link: "https://issuu.com/trenducsd/docs/fw2021_compressed__1_",
    description: "Our F/W 2021 issue explores the evolution of our dreams and creative endeavors within the last rocky year and hopes to keep UCSD creatives connected by sharing them with you all. Flip through the work of our members and contributors to float through our Past, Present, and Future dreams with us."
  },
  {
    picture: require("../../static/issues/(re)connecting.jpg"),
    title: "(re)connecting",
    link: "https://issuu.com/trenducsd/docs/_final_ss20-individualpages",
    description: "During the months that this issue came together, UCSD went remote to fight the spread of COVID-19. This issue is a time capsule — a look back at how we've spent our time in quarantine. Allow these stories to let you reflect on what quarantine has meant to you."
  },
  {
    picture: require("../../static/issues/duality.jpg"),
    title: "Duality",
    link: "https://issuu.com/trenducsd/docs/fw20-duality-single-pages",
    description: "In this issue, we attempt to unveil the truth behind a reality in which there are polar opposties. In this issue, we explore what happens at the in-between and what it means to us."
  },
  {
    picture: require("../../static/issues/the-shift.jpg"),
    title: "The Shift",
    link: "https://issuu.com/trenducsd/docs/trend_ss19",
    description: "As we approach the end of the decade, we wanted to use this issue as an opportunity to document the past ten years. We were faced with this enormous challenege to understand what the past ten years have felt like for the people that have experienced it in many different ways."
  },
  {
    picture: require("../../static/issues/sincerely-yours.jpg"),
    title: "Sincerely Yours",
    link: "https://issuu.com/trenducsd/docs/sincerelyyoursdigital-ilovepdf-comp",
    description: "This issue is dedicated to the complexities, joys, and challenges we face in life as we constantly transition from one stage to the next. Look inside for a collection of full stories, fleeting memories and an intimate look at what it means to be human."
  },
];